"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A987))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRHeartFilled = createSVGIcon(
  <path
    d="M20.438 4.804a5.306 5.306 0 0 1 0 7.504l-8.442 8.442-8.442-8.442a5.306 5.306 0 0 1 7.504-7.504l.938.938.938-.938a5.306 5.306 0 0 1 7.504 0Z"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRHeartFilled",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
